import React from 'react';
const common = require('../common/common');
const env = require("../../config.js").default;

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUrl: false,
    };
  }

  componentDidMount() {
    const { url } = this.props;
    if (url) {
      setTimeout(() => {
        this.setState({ showUrl: true });
      }, 6000);
    }
  }
  
  render(props) {
    const { url } = this.props;
    const { text } = this.props;
    
    return (
      <div className="content_testo">
        <div id="content-core">
          <div className="row background_aggiornamento" style={{ position: 'relative' }}>
            <div className="col-xl-12 text-center content_error">
              <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
                <img src={env.STATIC + "custom/logo_" + env.CSOFT + ".png"} className="loaderLogo" alt="Logo" />
                <h4 className="pt-3 loadingText">{text || common.getTrad("Caricamento in corso...").replace("...", "")}</h4>
              </div>
            </div>
            {this.state.showUrl && (
              <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2" style={{ position: 'absolute', bottom: '20%' }}>
                <h6>{common.getTrad("Se non sei ancora stato reindirizzato clicca il seguente link:")}</h6>
                <a href={url}>{url}</a>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Loader;
